import * as React from "react";
function SvgMagic(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M11.9 20.3l2-4.3 4.3-2-4.3-2-2-4.3-2 4.3-4.3 2 4.3 2 2 4.3zm0 5.6l-3.8-8.2L0 14l8.2-3.7L12 2.1l3.7 8.2 8.2 3.7-8.2 3.8L12 26zM26 30l-1.9-4.1L20 24l4.1-1.9L26 18l1.9 4.1L32 24l-4.1 1.9L26 30z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgMagic);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
